import { Slot } from "@gigpro/ui/Slot";
import { cn } from "@gigpro/ui/tailwind/cn";
import { cva, type VariantProps } from "class-variance-authority";
import type React from "react";

const variants = cva(
  "inline-flex items-center justify-center rounded-full bg-light-gray text-small font-semibold [&>button]:text-black",
  {
    variants: {
      size: {
        small: "gap-0.5 px-1.5 py-0.5 text-small [&>button]:-mr-0.5 [&>button]:p-0.5",
        medium: "gap-1 px-1.5 py-1 text-normal",
      },
    },
    defaultVariants: {
      size: "small",
    },
  },
);

interface ChipProps extends React.ComponentProps<"span">, VariantProps<typeof variants> {
  asChild?: boolean;
}

export const Chip = ({ ref, size, className, asChild, ...props }: ChipProps) => {
  const Comp = asChild ? Slot : "span";
  return <Comp ref={ref} className={cn(variants({ size }), className)} {...props} />;
};
